import { create } from 'zustand';
import type { OpenChatPlatformLink } from './ChatMessageLink';
import { useCanvasStore } from './canvas-store';

export const useChatPlatformNavigation = create<{ target: { brandId: number; productId?: number; competitorId?: number; competitorTab?: 'fbads' } | null }>(() => ({ target: null }));
export const openChatPlatformLink: OpenChatPlatformLink = target => {
  useChatPlatformNavigation.setState({ target: { brandId: target.brandId, productId: target.productId, competitorId: target.competitorId, ...(target.competitorTab?{competitorTab:target.competitorTab}:{}) } });
  // Brands is a standalone destination, just like the sidebar. Detach the
  // task before switching views so its persisted chat view stays intact.
  useCanvasStore.setState({ activeTaskId: null, activeProjectId: null });
  useCanvasStore.getState().setActiveView('brands');
};
